import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { useHistory } from 'react-router'

import Render from './RegisterRender'

function Register ({ id }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({})
  const [getLoading, setLoading] = useState(true)
  const [getAncoras, setAncoras] = useState([])
  const dispatch = useDispatch()

  const getInfoForForm = async () => {
    try {
      const findAncoraLoja = await api.get(`AncorasLojasCodigos/ConsultarId?id=${id}`)
      const findAncoras = await api.get('AncorasLojas/Consultar')
      setInputs(findAncoraLoja.data.resposta)
      setAncoras(findAncoras.data.resposta)
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-lojas-codigos'))

    const permissions = getPermissions({ moduloId: 1928, permissao: 'Alterar' })

    if (permissions) {
      getInfoForForm()
    } else {
      history.push('/app')
    }
  }, [])

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    getAncoras={getAncoras}
  />
}

export default Register
